import React, { useState } from 'react';
import { AsyncSelect } from '../../../../components/Select/async';
import { ScorecardTemplateService } from '../../../../services/v1/applicant_tracking/ScorecardTemplateService';
import { ScorecardTemplateList } from '../../../../entities/v1/applicant_tracking/ScorecardTemplateList';

export type StartingPoint =
  | { value: string; label: string }
  | 'FROM_SCRATCH'
  | undefined;

interface PropTypes {
  startingPoint: StartingPoint;
  onStartingPointChange: (value: StartingPoint) => void;
}

export function StartingPointSelector(props: PropTypes) {
  const [selectEnabled, setSelectEnabled] = useState<boolean>(
    props.startingPoint != null && props.startingPoint != 'FROM_SCRATCH',
  );
  const [scorecardTemplates] = useState(
    ScorecardTemplateService.list({ expand: ['survey_template'] }),
  );

  return (
    <div className='d-flex align-items-center'>
      <div className='form-check form-check-inline'>
        <input
          className='form-check-input'
          type='radio'
          checked={!selectEnabled}
          onChange={() => {
            setSelectEnabled(false);
            props.onStartingPointChange('FROM_SCRATCH');
          }}
        />
        <label className='form-check-label'>Custom</label>
      </div>
      <div className='form-check form-check-inline'>
        <input
          className='form-check-input'
          type='radio'
          checked={selectEnabled}
          onChange={() => {
            setSelectEnabled(true);
            props.onStartingPointChange(undefined);
          }}
        />
        <label className='form-check-label'>Based on template</label>
      </div>
      <AsyncSelect
        placeholder='Select scorecard'
        className='d-inline-block flex-grow-1'
        loadOptions={(q: string) =>
          filterScorecardTemplates(scorecardTemplates, q)
        }
        selected={selectedOption(props.startingPoint)}
        onChange={(newOption) => {
          props.onStartingPointChange(newOption);
        }}
        disabled={!selectEnabled}
      />
    </div>
  );
}

async function filterScorecardTemplates(
  scorecards: Promise<ScorecardTemplateList>,
  q: string,
) {
  return scorecards.then((list) =>
    list.scorecardTemplates
      .filter((template) =>
        template.surveyTemplate.name.toLowerCase().includes(q.toLowerCase()),
      )
      .map((template) => ({
        value: template.id.toString(),
        label: template.surveyTemplate.name,
      })),
  );
}

function selectedOption(startingPoint: StartingPoint) {
  if (!startingPoint) return undefined;
  if (typeof startingPoint === 'string') return undefined;

  return startingPoint;
}
